<template>
  <base-section
    id="basic-estimate"
  >
    <v-container>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="7"
        >
          <v-card>
            <v-col>
              <base-section-heading
                title="Loan Estimate"
                space="0"
                outlined
              />
              <v-simple-table>
                <thead>
                  <tr />
                </thead>

                <tbody class="body-1">
                  <tr
                    v-for="([name, one, two], i) in loanEstimate"
                    :key="i"
                    :class="i !== 5 ? '' : 'grey lighten-3'"
                  >
                    <td>
                      {{ name }}
                    </td>

                    <td class="text-center font-weight-bold">
                      {{ i === 1 ? `${one}%` : formatCurrency(one) }}
                    </td>

                    <td class="text-center font-weight-bold">
                      <template v-if="typeof two === 'boolean'">
                        <v-icon :color="two ? 'success' : 'error'">
                          mdi-{{ two ? 'check' : 'close' }}
                        </v-icon>
                      </template>

                      <template v-else>
                        {{ two }}
                      </template>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-card>

          <br>
          <br>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-col>
              <base-section-heading
                title="Closing Cost Details"
                space="0"
                outlined
              />

              <v-row>
                <v-col>
                  <v-card>
                    <v-col>
                      <base-title
                        title="Loan Costs"
                        class="text-uppercase"
                        space="0"
                        size="subtitle-1"
                      />
                    </v-col>
                    <v-col>
                      <v-card>
                        <v-col>
                          <v-simple-table>
                            <thead>
                              <base-title
                                title="Origination Charges"
                                class="text-uppercase"
                                space="0"
                                size="subtitle-1"
                              />

                              <tr />
                            </thead>

                            <tbody class="body-1">
                              <tr
                                v-for="([name, one, two], i) in loanCosts.originationCharges"
                                :key="i"
                                :class="i !== 0 ? '' : 'grey lighten-3'"
                              >
                                <td>
                                  {{ name }}
                                </td>

                                <td class="text-center font-weight-bold">
                                  {{ formatCurrency(one) }}
                                </td>

                                <td class="text-center font-weight-bold">
                                  <template v-if="typeof two === 'boolean'">
                                    <v-icon :color="two ? 'success' : 'error'">
                                      mdi-{{ two ? 'check' : 'close' }}
                                    </v-icon>
                                  </template>

                                  <template v-else>
                                    {{ two }}
                                  </template>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-col>
                      </v-card>
                      <br>
                      <v-card>
                        <v-col>
                          <v-simple-table>
                            <thead>
                              <base-title
                                title="Services You Cannot Shop For"
                                class="text-uppercase"
                                space="0"
                                size="subtitle-1"
                              />

                              <tr />
                            </thead>

                            <tbody class="body-1">
                              <tr
                                v-for="([name, one, two], i) in loanCosts.servicesYouCannotShopFor"
                                :key="i"
                                :class="i !== 0 ? '' : 'grey lighten-3'"
                              >
                                <td>
                                  {{ name }}
                                </td>

                                <td class="text-center font-weight-bold">
                                  {{ formatCurrency(one) }}
                                </td>

                                <td class="text-center font-weight-bold">
                                  <template v-if="typeof two === 'boolean'">
                                    <v-icon :color="two ? 'success' : 'error'">
                                      mdi-{{ two ? 'check' : 'close' }}
                                    </v-icon>
                                  </template>

                                  <template v-else>
                                    {{ two }}
                                  </template>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-col>
                      </v-card>
                      <br>
                      <v-card>
                        <v-col>
                          <v-simple-table>
                            <thead>
                              <base-title
                                title="Services You Can Shop For"
                                class="text-uppercase"
                                space="0"
                                size="subtitle-1"
                              />

                              <tr />
                            </thead>

                            <tbody class="body-1">
                              <tr
                                v-for="([name, one, two], i) in loanCosts.servicesYouCanShopFor"
                                :key="i"
                                :class="i !== 0 ? '' : 'grey lighten-3'"
                              >
                                <td>
                                  {{ name }}
                                </td>

                                <td class="text-center font-weight-bold">
                                  {{ formatCurrency(one) }}
                                </td>

                                <td class="text-center font-weight-bold">
                                  <template v-if="typeof two === 'boolean'">
                                    <v-icon :color="two ? 'success' : 'error'">
                                      mdi-{{ two ? 'check' : 'close' }}
                                    </v-icon>
                                  </template>

                                  <template v-else>
                                    {{ two }}
                                  </template>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-col>
                      </v-card>
                    </v-col>
                  </v-card>
                </v-col>

                <v-col>
                  <v-card>
                    <v-col>
                      <base-title
                        title="Other Costs"
                        class="text-uppercase"
                        space="0"
                        size="subtitle-1"
                      />
                    </v-col>
                    <v-col>
                      <v-card>
                        <v-col>
                          <v-simple-table>
                            <thead>
                              <base-title
                                title="Taxes and Other Government Fees"
                                class="text-uppercase"
                                space="0"
                                size="subtitle-1"
                              />

                              <tr />
                            </thead>

                            <tbody class="body-1">
                              <tr
                                v-for="([name, one, two], i) in otherCosts.taxesAndOtherGovernmentFees"
                                :key="i"
                                :class="i !== 0 ? '' : 'grey lighten-3'"
                              >
                                <td>
                                  {{ name }}
                                </td>

                                <td class="text-center font-weight-bold">
                                  {{ formatCurrency(one) }}
                                </td>

                                <td class="text-center font-weight-bold">
                                  <template v-if="typeof two === 'boolean'">
                                    <v-icon :color="two ? 'success' : 'error'">
                                      mdi-{{ two ? 'check' : 'close' }}
                                    </v-icon>
                                  </template>

                                  <template v-else>
                                    {{ two }}
                                  </template>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-col>
                      </v-card>
                      <br>
                      <v-card>
                        <v-col>
                          <v-simple-table>
                            <thead>
                              <base-title
                                title="Prepaids"
                                class="text-uppercase"
                                space="0"
                                size="subtitle-1"
                              />

                              <tr />
                            </thead>

                            <tbody class="body-1">
                              <tr
                                v-for="([name, one, two], i) in otherCosts.prepaids"
                                :key="i"
                                :class="i !== 0 ? '' : 'grey lighten-3'"
                              >
                                <td>
                                  {{ name }}
                                </td>

                                <td class="text-center font-weight-bold">
                                  {{ formatCurrency(one) }}
                                </td>

                                <td class="text-center font-weight-bold">
                                  <template v-if="typeof two === 'boolean'">
                                    <v-icon :color="two ? 'success' : 'error'">
                                      mdi-{{ two ? 'check' : 'close' }}
                                    </v-icon>
                                  </template>

                                  <template v-else>
                                    {{ two }}
                                  </template>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-col>
                      </v-card>
                      <br>
                      <v-card>
                        <v-col>
                          <v-simple-table>
                            <thead>
                              <base-title
                                title="Initial Escrow Payment at Closing"
                                class="text-uppercase"
                                space="0"
                                size="subtitle-1"
                              />

                              <tr />
                            </thead>

                            <tbody class="body-1">
                              <tr
                                v-for="([name, one, two], i) in otherCosts.initialEscrowPaymentAtClosing"
                                :key="i"
                                :class="i !== 0 ? '' : 'grey lighten-3'"
                              >
                                <td>
                                  {{ name }}
                                </td>

                                <td class="text-center font-weight-bold">
                                  {{ formatCurrency(one) }}
                                </td>

                                <td class="text-center font-weight-bold">
                                  <template v-if="typeof two === 'boolean'">
                                    <v-icon :color="two ? 'success' : 'error'">
                                      mdi-{{ two ? 'check' : 'close' }}
                                    </v-icon>
                                  </template>

                                  <template v-else>
                                    {{ two }}
                                  </template>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-col>
                      </v-card>
                    </v-col>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-card>
                    <v-col>
                      <v-simple-table>
                        <thead>
                          <base-title
                            title="Calculating Cash to Close"
                            class="text-uppercase"
                            space="0"
                            size="subtitle-1"
                          />

                          <tr />
                        </thead>

                        <tbody class="body-1">
                          <tr
                            v-for="([name, one, two], i) in calculatingCashToClose"
                            :key="i"
                            :class="i !== 5 ? '' : 'grey lighten-3'"
                          >
                            <td>
                              {{ name }}
                            </td>

                            <td class="text-center font-weight-bold">
                              {{ formatCurrency(one) }}
                            </td>

                            <td class="text-center font-weight-bold">
                              <template v-if="typeof two === 'boolean'">
                                <v-icon :color="two ? 'success' : 'error'">
                                  mdi-{{ two ? 'check' : 'close' }}
                                </v-icon>
                              </template>

                              <template v-else>
                                {{ two }}
                              </template>
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-col>
                  </v-card>
                </v-col>
                <v-col>
                  <v-simple-table>
                    <thead>
                      <base-title
                        title="Total Closing Costs"
                        class="text-uppercase"
                        space="0"
                        size="subtitle-1"
                      />

                      <tr />
                    </thead>

                    <tbody class="body-1">
                      <tr
                        v-for="([name, one, two], i) in totalCosts"
                        :key="i"
                        :class="i !== 5 ? '' : 'grey lighten-3'"
                      >
                        <td>
                          {{ name }}
                        </td>

                        <td class="text-center font-weight-bold">
                          {{ formatCurrency(one) }}
                        </td>

                        <td class="text-center font-weight-bold">
                          <template v-if="typeof two === 'boolean'">
                            <v-icon :color="two ? 'success' : 'error'">
                              mdi-{{ two ? 'check' : 'close' }}
                            </v-icon>
                          </template>

                          <template v-else>
                            {{ two }}
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionBasicEstimate',

    data: () => ({
      estimateParameters: {
        loanAmount: 299000,
        interestRate: 2.0,
        propertyTaxes: 500, //
        homeownersInsurance: 900, //
        // titleInsurance: 400, // necessary?
        deferYears: 2,
        // monthlyPayment: 1517,
        principalAndInterest: 1240,
      },

      loanEstimate: [
        ['Loan Amount', 299000],
        ['Interest Rate', 2.875],
        ['Monthly Principal & Interest', 1240],
        ['Mortgage Insurance', 0],
        ['Estimated Taxes, Insurance, & Assessments', 276],
        ['Estimated Monthly Payment', 1517],
        ['Estimated Closing Costs', 6835],
        ['Estimated Cash to Close', 794],
      ],
      loanCosts: {
        originationCharges: [
          ['Total', 1524],
          ['1% of Loan Amount (Points)', 469],
          ['Underwriting Fee', 1055],
        ],
        servicesYouCannotShopFor: [
          ['Total', 619],
          ['Appraisal Fee', 495],
          ['Credit Report', 31],
          ['Flood Certification', 8],
          ['Tax Service', 85],
        ],
        servicesYouCanShopFor: [
          ['Total', 1261],
          ['Title - Closing Protection Letter Fee', 25],
          ['Title - Endorsement Fee', 60],
          ['Title - Premium for Lender\'s Coverage', 926],
          ['Title - Recording Fee', 100],
          ['Title - Settlement Or Closing Fee', 150],
        ],
        totalLoanCosts: 3404,
      },
      otherCosts: {
        taxesAndOtherGovernmentFees: [
          ['Total', 80],
          ['Recording Fees and Other Taxes', 80],
          ['Transfer Taxes', 0],
        ],
        prepaids: [
          ['Total', 330],
          ['Home Owner\'s Insurance Premium', 0],
          ['Mortgage Insurance Premium', 0],
          ['Prepaid Interest', 330],
          ['Property Taxes', 0],
        ],
        initialEscrowPaymentAtClosing: [
          ['Total', 3021],
          ['Homeowner\'s Insurance', 205],
          ['Property Taxes', 2816],
        ],
        other: [
          ['Total', 0],
        ],
        totalOtherCosts: 3431,
      },
      calculatingCashToClose: [
        ['Loan Amount', 299000],
        ['Total Closing Costs', -6835],
        ['Estimated Total Payoffs and Payments', 0],
        ['Estimated Cash to Close From Borrower', 794],
        ['Estimated Cash to Close To Borrower', 0],
        ['Estimated Closing Costs Financed (Paid from your Loan Amount)', 6041],
      ],
      totalCosts: [
        ['Total Other Costs', 3461],
        ['Total Loan Costs', 3404],
        ['Total Closing Costs', 6835],
      ],
    }),
    beforeMount () {
      if (this.$route.query) {
        const q = this.$route.query
        if (q.deferYears) {
          this.estimateParameters.deferYears = parseInt(q.deferYears)
        }
        if (q.homeownersInsurance) {
          this.estimateParameters.homeownersInsurance = parseInt(q.homeownersInsurance)
        }
        if (q.interestRate) {
          this.estimateParameters.interestRate = parseFloat(q.interestRate)
        }
        if (q.loanAmount) {
          this.estimateParameters.loanAmount = parseInt(q.loanAmount)
        }
        // if (q.monthlyPayment) {
        //   this.estimateParameters.monthlyPayment = q.monthlyPayment
        // }
        if (q.principalAndInterest) {
          this.estimateParameters.principalAndInterest = parseInt(q.principalAndInterest)
        }
        if (q.propertyTaxes) {
          this.estimateParameters.propertyTaxes = parseInt(q.propertyTaxes)
        }
        // if (q.titleInsurance) {
        //   this.estimate.titleInsurance = q.titleInsurance
        // }
      }

      // console.log(this.$route.query.propertyTaxes)
      // console.log(this.$route.query.homeownersInsurance)
      // console.log(this.$route.query.loanAmount)

      this.setLoanAmount(this.estimateParameters.loanAmount)
      this.setInterestRate(this.estimateParameters.interestRate)
      this.setPrincipalAndInterest(this.estimateParameters.principalAndInterest)
      this.setMortgageInsurance(this.calculateMortgageInsurance())
      this.setTaxesEtc(this.calculateTaxesEtc())
      this.setMonthlyPayment(this.calculateMonthlyPayment())
      // this.setClosingCosts(this.calculateClosingCosts())
      // this.setCashToClose(this.calculateCashToClose())

      this.setOnePercentAmount(Math.ceil(this.estimateParameters.loanAmount / 100))
      this.setUnderwritingFee(this.calculateUnderwritingFee())
      this.setTotalOrigination(this.calculateTotal(this.loanCosts.originationCharges)) // set last in group

      this.setAppraisalFee(this.calculateAppraisalFee())
      this.setCreditReport(this.calculateCreditReport())
      this.setFloodCertification(this.calculateFloodCertification())
      this.setTaxService(this.calculateTaxService())
      this.setTotalServicesYouCannotShopFor(this.calculateTotal(this.loanCosts.servicesYouCannotShopFor)) // last in group

      this.setClosingProtectionLetterFee(this.calculateClosingProtectionLetterFee())
      this.setEndorsementFee(this.calculateEndorsementFee())
      this.setLenderCoveragePremium(this.calculateLenderCoveragePremium())
      this.setRecordingFee(this.calculateRecordingFee())
      this.setClosingFee(this.calculateClosingFee())
      this.setTotalServicesYouCanShopFor(this.calculateTotal(this.loanCosts.servicesYouCanShopFor)) // last in group

      this.setTotalLoanCosts(this.calculateTotalLoanCosts()) // after all loanCosts calculations

      this.setRecordingFeesAndOtherTaxes(this.calculateRecordingFeesAndOtherTaxes())
      this.setTransferTaxes(this.calculateTransferTaxes())
      this.setTotalTaxesAndOtherGovFees(this.calculateTotal(this.otherCosts.taxesAndOtherGovernmentFees))

      this.setHomeownersInsurancePremium(this.calculateHomeownersInsurancePremium())
      this.setMortgageInsurancePremium(this.calculateMortgageInsurancePremium())
      this.setPrepaidInterest(this.calculatePrepaidInterest())
      this.setPropertyTaxes(this.calculatePropertyTaxes()) // not sure if this is the right field
      this.setTotalPrepaids(this.calculateTotal(this.otherCosts.prepaids))

      this.setHomeownersInsuranceEscrow(this.calculateHomeownersInsuranceEscrow())
      this.setPropertyTaxesEscrow(this.estimateParameters.propertyTaxes * 2) // not sure if right field
      this.setTotalEscrow(this.calculateTotal(this.otherCosts.initialEscrowPaymentAtClosing))

      this.setOtherOtherCosts(this.calculateOtherOtherCosts())

      this.setTotalOtherCosts(this.calculateTotalOtherCosts()) // last in otherCosts

      this.setTotalClosingCosts(this.calculateTotalClosingCosts())
      this.setEstimatedCashFromBorrower(this.calculateEstimatedCashFromBorrower())
      this.setEstimatedCashToBorrower(this.calculateEstimatedCashToBorrower())
      this.setEstimatedClosingCostsFinanced(this.calculateEstimatedClosingCostsFinanced())
      this.setEstimatedTotalPayoffs(this.calculateEstimatedTotalPayoffs())
    },
    methods: {
      calculateTotal (list) { // ignores first value and puts total in [0][1]
        let total = 0
        for (let i = 1; i < list.length; i++) {
          if (typeof list[i][1] !== 'undefined') {
            total += list[i][1]
          }
        }
        return total
      },
      calculateTotalLoanCosts () {
        let total = 0
        total += this.loanCosts.originationCharges[0][1]
        total += this.loanCosts.servicesYouCannotShopFor[0][1]
        total += this.loanCosts.servicesYouCanShopFor[0][1]
        return total
      },
      calculatePrincipalAndInterest () { // TODO
        return 1240
      },
      calculateMortgageInsurance () { // TODO
        return 0
      },
      calculateTaxesEtc () { // TODO
        return this.estimateParameters.propertyTaxes + this.estimateParameters.homeownersInsurance
      },
      calculateMonthlyPayment () { // TODO
        return this.estimateParameters.propertyTaxes + this.estimateParameters.homeownersInsurance + this.estimateParameters.principalAndInterest
      },
      calculateClosingCosts () { // TODO
        return 6835
      },
      calculateCashToClose () { // TODO
        return 794
      },
      calculateUnderwritingFee () {
        return 1055
      },
      calculateAppraisalFee () {
        return 495
      },
      calculateCreditReport () {
        return 31
      },
      calculateFloodCertification () {
        return 8
      },
      calculateTaxService () {
        return 85
      },
      calculateClosingProtectionLetterFee () {
        return 25
      },
      calculateEndorsementFee () {
        return 60
      },
      calculateLenderCoveragePremium () {
        // return 926
        let loanAmount = this.estimateParameters.loanAmount
        if (loanAmount < 20001) {
          loanAmount = 20001
        } else if (loanAmount > 3000001) {
          loanAmount = 3000001
        }
        return this.getPremium(Math.floor((loanAmount - 1) / 10000) * 10000 + 1)
      },
      calculateRecordingFee () {
        return 100
      },
      calculateClosingFee () {
        return 150
      },
      calculateRecordingFeesAndOtherTaxes () {
        return 80
      },
      calculateTransferTaxes () {
        return 0
      },
      calculateHomeownersInsurancePremium () {
        return 0
      },
      calculateMortgageInsurancePremium () {
        return 0
      },
      calculatePrepaidInterest () { // is this 10%?
        // return Math.floor(this.estimateParameters.loanAmount * (2 * Math.floor(this.estimateParameters.deferYears) * 0.0))
        return Math.floor(((this.estimateParameters.loanAmount * 0.02) / 365) * 15)
      },
      calculatePropertyTaxes () {
        return 0
      },
      calculateHomeownersInsuranceEscrow () {
        return 205
      },
      calculatePropertyTaxesEscrow () {
        return 2816
      },
      calculateOtherOtherCosts () {
        return 0
      },
      calculateTotalOtherCosts () {
        let total = 0
        total += this.otherCosts.taxesAndOtherGovernmentFees[0][1]
        total += this.otherCosts.prepaids[0][1]
        total += this.otherCosts.initialEscrowPaymentAtClosing[0][1]
        total += this.otherCosts.other[0][1]
        return total
      },
      calculateTotalClosingCosts () {
        let total = 0
        total += this.loanCosts.totalLoanCosts
        total += this.otherCosts.totalOtherCosts
        return total
      },
      calculateEstimatedTotalPayoffs () {
        // console.log(this.estimateParameters)
        // console.log(this.calculatingCashToClose[5][1])
        // console.log(this.estimateParameters.loanAmount - this.calculatingCashToClose[5][1])
        return this.estimateParameters.loanAmount - this.calculatingCashToClose[5][1]
      },
      calculateEstimatedCashFromBorrower () {
        return 0
      },
      calculateEstimatedCashToBorrower () {
        return 0
      },
      calculateEstimatedClosingCostsFinanced () {
        return this.totalCosts[2][1]
      },

      setLoanAmount (val) {
        this.loanEstimate[0][1] = val
        this.calculatingCashToClose[0][1] = val
      },
      setInterestRate (val) {
        this.loanEstimate[1][1] = val
      },
      setPrincipalAndInterest (val) {
        this.loanEstimate[2][1] = val
      },
      setMortgageInsurance (val) {
        this.loanEstimate[3][1] = val // is this passed in props?
      },
      setTaxesEtc (val) {
        this.loanEstimate[4][1] = val // is this passed in props?
      },
      setMonthlyPayment (val) {
        this.loanEstimate[5][1] = val
      },
      setClosingCosts (val) {
        this.loanEstimate[6][1] = val
      },
      setCashToClose (val) {
        this.loanEstimate[7][1] = val
      },
      setTotalOrigination (val) {
        this.loanCosts.originationCharges[0][1] = val
      },
      setOnePercentAmount (val) {
        this.loanCosts.originationCharges[1][1] = val
      },
      setUnderwritingFee (val) {
        this.loanCosts.originationCharges[2][1] = val
      },
      setTotalServicesYouCannotShopFor (val) {
        this.loanCosts.servicesYouCannotShopFor[0][1] = val
      },
      setAppraisalFee (val) {
        this.loanCosts.servicesYouCannotShopFor[1][1] = val
      },
      setCreditReport (val) {
        this.loanCosts.servicesYouCannotShopFor[2][1] = val
      },
      setFloodCertification (val) {
        this.loanCosts.servicesYouCannotShopFor[3][1] = val
      },
      setTaxService (val) {
        this.loanCosts.servicesYouCannotShopFor[4][1] = val
      },
      setTotalServicesYouCanShopFor (val) {
        this.loanCosts.servicesYouCanShopFor[0][1] = val
      },
      setClosingProtectionLetterFee (val) {
        this.loanCosts.servicesYouCanShopFor[1][1] = val
      },
      setEndorsementFee (val) {
        this.loanCosts.servicesYouCanShopFor[2][1] = val
      },
      setLenderCoveragePremium (val) {
        this.loanCosts.servicesYouCanShopFor[3][1] = val
      },
      setRecordingFee (val) {
        this.loanCosts.servicesYouCanShopFor[4][1] = val
      },
      setClosingFee (val) {
        this.loanCosts.servicesYouCanShopFor[5][1] = val
      },
      setTotalLoanCosts (val) {
        this.loanCosts.totalLoanCosts = val
        this.totalCosts[1][1] = val
      },
      setTotalTaxesAndOtherGovFees (val) {
        this.otherCosts.taxesAndOtherGovernmentFees[0][1] = val
      },
      setRecordingFeesAndOtherTaxes (val) {
        this.otherCosts.taxesAndOtherGovernmentFees[1][1] = val
      },
      setTransferTaxes (val) {
        this.otherCosts.taxesAndOtherGovernmentFees[2][1] = val
      },
      setTotalPrepaids (val) {
        this.otherCosts.prepaids[0][1] = val
      },
      setHomeownersInsurancePremium (val) {
        this.otherCosts.prepaids[1][1] = val
      },
      setMortgageInsurancePremium (val) { // be careful not to use setMortgageInsurance... maybe refactor
        this.otherCosts.prepaids[2][1] = val
      },
      setPrepaidInterest (val) {
        this.otherCosts.prepaids[3][1] = val
      },
      setPropertyTaxes (val) {
        this.otherCosts.prepaids[4][1] = val
      },
      setTotalEscrow (val) {
        this.otherCosts.initialEscrowPaymentAtClosing[0][1] = val
      },
      setHomeownersInsuranceEscrow (val) {
        this.otherCosts.initialEscrowPaymentAtClosing[1][1] = val
      },
      setPropertyTaxesEscrow (val) {
        this.otherCosts.initialEscrowPaymentAtClosing[2][1] = val
      },
      setOtherOtherCosts (val) { // need to differentiate between this and totalOtherCosts
        this.otherCosts.other[0][1] = val
      },
      setTotalOtherCosts (val) {
        this.otherCosts.totalOtherCosts = val
        this.totalCosts[0][1] = val
      },
      setTotalClosingCosts (val) {
        this.calculatingCashToClose[1][1] = val
        this.totalCosts[2][1] = val
        this.loanEstimate[6][1] = val
      },
      setEstimatedTotalPayoffs (val) {
        this.calculatingCashToClose[2][1] = val
      },
      setEstimatedCashFromBorrower (val) {
        this.calculatingCashToClose[3][1] = val
        this.loanEstimate[7][1] = val
      },
      setEstimatedCashToBorrower (val) {
        this.calculatingCashToClose[4][1] = val
      },
      setEstimatedClosingCostsFinanced (val) {
        this.calculatingCashToClose[5][1] = val
      },

      formatCurrency (amount) { // https://stackoverflow.com/questions/149055/how-to-format-numbers-as-currency-string
        try {
          const decimalCount = 0
          const negativeSign = amount < 0 ? '-' : ''

          const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
          const j = (i.length > 3) ? i.length % 3 : 0

          return '$' + negativeSign + (j ? i.substr(0, j) + ',' : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + ',')
        } catch (e) {
          // console.log(e)
        }
      },

      getPremium (loanAmount) {
        const premiumsDict = {
          20001: 200,
          30001: 207,
          40001: 233,
          50001: 263,
          60001: 293,
          70001: 324,
          80001: 354,
          90001: 384,
          100001: 412,
          110001: 440,
          120001: 467,
          130001: 495,
          140001: 523,
          150001: 550,
          160001: 578,
          170001: 605,
          180001: 633,
          190001: 661,
          200001: 683,
          210001: 705,
          220001: 727,
          230001: 749,
          240001: 771,
          250001: 793,
          260001: 815,
          270001: 837,
          280001: 860,
          290001: 882,
          300001: 904,
          310001: 926,
          320001: 948,
          330001: 970,
          340001: 992,
          350001: 1014,
          360001: 1036,
          370001: 1058,
          380001: 1080,
          390001: 1103,
          400001: 1125,
          410001: 1147,
          420001: 1169,
          430001: 1191,
          440001: 1213,
          450001: 1235,
          460001: 1257,
          470001: 1279,
          480001: 1301,
          490001: 1324,
          500001: 1335,
          510001: 1346,
          520001: 1357,
          530001: 1368,
          540001: 1379,
          550001: 1390,
          560001: 1401,
          570001: 1412,
          580001: 1423,
          590001: 1434,
          600001: 1445,
          610001: 1456,
          620001: 1467,
          630001: 1478,
          640001: 1489,
          650001: 1500,
          660001: 1511,
          670001: 1522,
          680001: 1533,
          690001: 1544,
          700001: 1556,
          710001: 1567,
          720001: 1578,
          730001: 1589,
          740001: 1600,
          750001: 1611,
          760001: 1622,
          770001: 1633,
          780001: 1644,
          790001: 1655,
          800001: 1666,
          810001: 1677,
          820001: 1688,
          830001: 1699,
          840001: 1710,
          850001: 1721,
          860001: 1732,
          870001: 1743,
          880001: 1754,
          890001: 1765,
          900001: 1776,
          910001: 1788,
          920001: 1799,
          930001: 1810,
          940001: 1821,
          950001: 1832,
          960001: 1843,
          970001: 1854,
          980001: 1865,
          990001: 1876,
          1000001: 1887,
          1010000: 1898,
          1020000: 1909,
          1030000: 1920,
          1040001: 1931,
          1050001: 1942,
          1060001: 1953,
          1070001: 1964,
          1080001: 1975,
          1090001: 1986,
          1100001: 1997,
          1110001: 2008,
          1120001: 2020,
          1130001: 2031,
          1140001: 2042,
          1150001: 2053,
          1160001: 2064,
          1170001: 2075,
          1180001: 2086,
          1190001: 2097,
          1200001: 2108,
          1210001: 2119,
          1220001: 2130,
          1230001: 2141,
          1240001: 2152,
          1250001: 2163,
          1260001: 2174,
          1270001: 2185,
          1280001: 2196,
          1290001: 2207,
          1300001: 2218,
          1310001: 2229,
          1320001: 2241,
          1330001: 2252,
          1340001: 2263,
          1350001: 2274,
          1360001: 2285,
          1370001: 2296,
          1380001: 2307,
          1390001: 2318,
          1400001: 2329,
          1410001: 2340,
          1420001: 2351,
          1430001: 2362,
          1440001: 2373,
          1450001: 2384,
          1460001: 2395,
          1470001: 2406,
          1480001: 2417,
          1490001: 2428,
          1500001: 2439,
          1510001: 2450,
          1520001: 2461,
          1530001: 2473,
          1540001: 2484,
          1550001: 2495,
          1560001: 2506,
          1570001: 2517,
          1580001: 2528,
          1590001: 2539,
          1600001: 2550,
          1610001: 2561,
          1620001: 2572,
          1630001: 2583,
          1640001: 2594,
          1650001: 2605,
          1660001: 2616,
          1670001: 2627,
          1680001: 2638,
          1690001: 2649,
          1700001: 2660,
          1710001: 2671,
          1720001: 2682,
          1730001: 2693,
          1740001: 2705,
          1750001: 2716,
          1760001: 2727,
          1770001: 2738,
          1780001: 2749,
          1790001: 2760,
          1800001: 2771,
          1810001: 2782,
          1820001: 2793,
          1830001: 2804,
          1840001: 2815,
          1850001: 2826,
          1860001: 2837,
          1870001: 2848,
          1880001: 2859,
          1890001: 2870,
          1900001: 2881,
          1910001: 2892,
          1920001: 2903,
          1930001: 2914,
          1940001: 2925,
          1950001: 2937,
          1960001: 2948,
          1970001: 2959,
          1980001: 2970,
          1990001: 2981,
          2000001: 2990,
          2010001: 3000,
          2020001: 3010,
          2030001: 3020,
          2040001: 3029,
          2050001: 3039,
          2060001: 3049,
          2070001: 3059,
          2080001: 3068,
          2090001: 3078,
          2100001: 3088,
          2110001: 3098,
          2120001: 3107,
          2130001: 3117,
          2140001: 3127,
          2150001: 3137,
          2160001: 3146,
          2170001: 3156,
          2180001: 3166,
          2190001: 3176,
          2200001: 3185,
          2210001: 3195,
          2220001: 3205,
          2230001: 3215,
          2240001: 3224,
          2250001: 3234,
          2260001: 3244,
          2270001: 3254,
          2280001: 3263,
          2290001: 3273,
          2300001: 3283,
          2310001: 3293,
          2320001: 3302,
          2330001: 3312,
          2340001: 3322,
          2350001: 3332,
          2360001: 3341,
          2370001: 3351,
          2380001: 3361,
          2390001: 3371,
          2400001: 3380,
          2410001: 3390,
          2420001: 3400,
          2430001: 3410,
          2440001: 3419,
          2450001: 3429,
          2460001: 3439,
          2470001: 3449,
          2480001: 3458,
          2490001: 3468,
          2500001: 3478,
          2510001: 3488,
          2520001: 3497,
          2530001: 3507,
          2540001: 3517,
          2550001: 3527,
          2560001: 3536,
          2570001: 3546,
          2580001: 3556,
          2590001: 3566,
          2600001: 3575,
          2610001: 3585,
          2620001: 3595,
          2630001: 3605,
          2640001: 3614,
          2650001: 3624,
          2660001: 3634,
          2670001: 3644,
          2680001: 3653,
          2690001: 3663,
          2700001: 3673,
          2710001: 3683,
          2720001: 3692,
          2730001: 3702,
          2740001: 3712,
          2750001: 3722,
          2760001: 3731,
          2770001: 3741,
          2780001: 3751,
          2790001: 3761,
          2800001: 3770,
          2810001: 3780,
          2820001: 3790,
          2830001: 3800,
          2840001: 3809,
          2850001: 3819,
          2860001: 3829,
          2870001: 3839,
          2880001: 3848,
          2890001: 3858,
          2900001: 3868,
          2910001: 3878,
          2920001: 3887,
          2930001: 3897,
          2940001: 3907,
          2950001: 3917,
          2960001: 3926,
          2970001: 3936,
          2980001: 3946,
          2990001: 3956,
          3000001: 3965,
        }
        // console.log(loanAmount, premiumsDict[loanAmount])
        return premiumsDict[loanAmount]
      },
    },
  }
</script>
